import {
  ROLE_FIELD_FILTER_REQUEST,
  ROLE_FIELD_FILTER_REQUEST_SUCCESS,
  ROLE_FIELD_FILTER_REQUEST_FAILURE,
  ROLE_FIELD_FILTER_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const roleFilterFieldsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case ROLE_FIELD_FILTER_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case ROLE_FIELD_FILTER_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case ROLE_FIELD_FILTER_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case ROLE_FIELD_FILTER_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default roleFilterFieldsReducer;
